export const en = {
    'minus-phrase-list': 'Negative keywords'
};
